import {
  BdsColorIllustrationCurationMedal1Svg,
  BdsMonoCommonArrowRightLarge1Svg,
  SpacingHeight4,
} from '@banksalad/bpl-web';
import { openWebView, WebViewType } from '@banksalad/js-banksalad';
import tw, { styled } from 'twin.macro';

import { useRouterWithQuery } from '@/page-src/prequalification/pages/loans/hooks/use-router-with-query';
import { useGetDeposits } from '@/page-src/product/pages/deposits/hooks/use-get-deposits';
import { useGetDepositsRank } from '@/page-src/product/pages/deposits/hooks/use-get-deposits-rank';
import { URL_PATH } from '@/src/constants/url-path';
import { useIsWebViewWithSsr } from '@/src/contexts/use-is-webview-with-ssr';
import { trackClickToEnterListFinancialProductSearchDetail } from '@/src/events/trackers/product/deposits/product-guid';
import { WEB_BASE_URL } from '@/src/utils/link';

export const ProductDepositRankSection = () => {
  const isWebViewWithSsr = useIsWebViewWithSsr();
  const { isValidProduct, result } = useGetDeposits();
  const { ranking } = useGetDepositsRank();
  const { routerPushWithQuery } = useRouterWithQuery();

  return (
    <Container
      onClick={() => {
        trackClickToEnterListFinancialProductSearchDetail(result.deposit, 'rank_section');
        if (isWebViewWithSsr) {
          openWebView({
            url: `${WEB_BASE_URL}${URL_PATH.CHART_DEPOSITS}`,
            type: WebViewType.WEB_VIEW_TYPE_SCREEN_FROM_RIGHT_TO_LEFT,
            nativeHeaderTitle: ' ',
          });
        } else {
          routerPushWithQuery(URL_PATH.CHART_DEPOSITS);
        }
      }}
    >
      <BdsColorIllustrationCurationMedal1Svg width={32} height={32} />

      <div css={tw`ml-22 flex-grow`}>
        <h2 css={tw`font-bold text-body-15 text-gray-300 leading-[23px]`}>예금 최고금리 순위</h2>
        <SpacingHeight4 />
        <p css={tw`text-head-20 font-extrabold leading-[28px]`}>
          {isValidProduct ? `${ranking}위` : '순위권 밖'}
        </p>
      </div>
      <BdsMonoCommonArrowRightLarge1Svg width={24} height={24} color="gray-500" />
    </Container>
  );
};

const Container = styled.div(tw`px-20 py-30 flex items-center bg-white-900 cursor-pointer`);
